'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { loadGA, trackGTMEvent } from '@/utils/analytics';

export default function GoogleAnalytics() {
  const pathname = usePathname();

  useEffect(() => {
    // GTM이 로드된 후 GA4 설정
    const timer = setTimeout(() => {
      loadGA();
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // 페이지 변경 시 GTM을 통한 페이지뷰 추적
    if (pathname) {
      trackGTMEvent('page_view', {
        page_path: pathname,
        page_title: document.title,
        event_category: 'navigation'
      });
    }
  }, [pathname]);

  return null;
}
